import * as types from './types'
import { GEO } from 'common/endpoints'

export const fetchCities = params => ({
  type: types.FETCH_CITIES,
  meta: {
    ...params,
    url: params.regionId ? GEO.citiesByRegion(params.regionId) : GEO.citiesByCountry(params.countryId),
  },
})

export const fetchRegions = countryId => ({
  type: types.FETCH_REGIONS,
  meta: {
    countryId,
    url: GEO.regions(countryId),
  },
})

export const searchCities = (countryId, start) => ({
  type: types.SEARCH_CITIES,
  meta: {
    countryId,
    start,
    url: GEO.search(countryId, start),
  },
})
